import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    notifications: {}
  },
  getters: {
    isAlarmed (state) {
      return !!Object.values(state.notifications).some(noti => noti && noti.isAcknowledged === false)
    }
  },
  mutations: {
    checkDevices (state, devices) {
      if (devices && devices.length !== 0) {
        for (let i = 0; i < devices.length; i++) {
          const device = devices[i]
          if (device.state_name === 'ALARM' || device.state_name === 'TROUBLE') {
            const notification = {
              content: device,
              isAcknowledged: device.ack_id != null
            }
            Vue.set(state.notifications, device.id.toString(), { ...notification })
          }
        }
      } else {
        state.notifications = {}
      }
    },
    add (state, payload) {
      const notification = {
        content: payload.content,
        isAcknowledged: false
      }
      Vue.set(state.notifications, payload.id.toString(), { ...notification })
    },
    acknowledge (state, device) {
      const noti = state.notifications[device.id]
      if (noti) { noti.isAcknowledged = true }
    }
  }
}
